module.exports = __webpack_public_path__ + "img/pvip2x.ae1ff747.png";